import { Text } from '@mantine/core'
import ReactMarkdown from 'react-markdown'

import { CollapsibleContentSection } from '@/components/CollapsibleContentSection'
import { TableContentGrid } from '@/components/TableContentGrid'

import { useContentModuleScreenData } from './ContentModuleScreen'

export function CustomizeDeliverySection() {
  const data = useContentModuleScreenData()

  const rows = [
    {
      heading: 'Delivery Style',
      content: data.cmQuery.data?.presentationStyle ? (
        <ReactMarkdown
          components={{
            p: ({ children }) => <Text mb="xs">{children}</Text>,
            ol: ({ children }) => (
              <Text component="ol" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
            ul: ({ children }) => (
              <Text component="ul" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
          }}>
          {data.cmQuery.data.presentationStyle}
        </ReactMarkdown>
      ) : (
        'Not specified'
      ),
    },
    {
      heading: 'Outline',
      content: data.cmQuery.data?.outline ? (
        <ReactMarkdown
          components={{
            p: ({ children }) => <Text mb="xs">{children}</Text>,
            ol: ({ children }) => (
              <Text component="ol" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
            ul: ({ children }) => (
              <Text component="ul" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
          }}>
          {data.cmQuery.data.outline}
        </ReactMarkdown>
      ) : (
        'Not specified'
      ),
    },
    {
      heading: 'Personality',
      content: data.cmQuery.data?.presentationPersonality ? (
        <ReactMarkdown
          components={{
            p: ({ children }) => <Text mb="xs">{children}</Text>,
            ol: ({ children }) => (
              <Text component="ol" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
            ul: ({ children }) => (
              <Text component="ul" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
          }}>
          {data.cmQuery.data.presentationPersonality}
        </ReactMarkdown>
      ) : (
        'Not specified'
      ),
    },
    /*
    {
      heading: 'Objectives',
      content: data.cmQuery.data?.presentationObjectives ? (
        <ReactMarkdown
          components={{
            p: ({ children }) => <Text mb="xs">{children}</Text>,
            ol: ({ children }) => (
              <Text component="ol" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
            ul: ({ children }) => (
              <Text component="ul" mt={0} mb="xs" style={{ paddingLeft: '1.5rem' }}>
                {children}
              </Text>
            ),
          }}>
          {data.cmQuery.data.presentationObjectives}
        </ReactMarkdown>
      ) : (
        'Not specified'
      ),
    },
    */
  ]

  return (
    <CollapsibleContentSection
      id="customize-delivery"
      title="Customize Delivery"
      subtitle="Configuration for how content is delivered to users."
      ContentElement={<TableContentGrid headingFlexWidth="245px" rows={rows} />}
    />
  )
}
